import api from '../../../services/api';
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import IconButton from '@mui/material/IconButton';
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function CadastroSC() {
    const { register, handleSubmit, reset } = useForm();
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const [funcionarios, setFuncionarios] = useState([]);
    const [setores, setSetores] = useState([]);
    const [setorSelecionado, setSetorSelecionado] = useState("");
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");
    const [unidadesMedida, setUnidadesMedida] = useState([]);
    const [listaDeItens, setListaDeItens] = useState([]);
    const [novoItem, setNovoItem] = useState({
        descricao: "",
        quantidade: "",
    });

    const adicionarItem = () => {
        if (!novoItem.descricao || !novoItem.quantidade) {
            mostrarAlerta("Descrição e Quantidade são obrigatórios!", "error");
            return;
        }

        setListaDeItens((prevItens) => [...prevItens, novoItem]);
        setNovoItem({ descricao: "", quantidade: "", volume: "", valorUnitario: "", valorTotal: "" });
        mostrarAlerta("Item adicionado à solicitação de compra!", "success");
        setTimeout(fecharAlerta, 3000);
    };

    const removerItem = (index) => {
        setListaDeItens((prevItens) => prevItens.filter((_, i) => i !== index));
    };

    useEffect(() => {
        async function fetchDataFuncionarios() {
            try {
                const response = await api.get(`/funcionario/lista`);
                setFuncionarios(response.data);
            } catch (error) {
                console.error('Erro ao buscar funcinarios:', error);
            }
        }
        fetchDataFuncionarios();
    }, []);

    useEffect(() => {
        async function fetchDataSetores() {
            try {
                const response = await api.get(`/setor`);
                setSetores(response.data);
            } catch (error) {
                console.error('Erro ao buscar setores:', error);
            }
        }
        fetchDataSetores();
    }, []);

    useEffect(() => {
        async function fetchDataUnidadesMedida() {
            try {
                const response = await api.get(`/unidadeMedida`);
                setUnidadesMedida(response.data);
            } catch (error) {
                console.error('Erro ao buscar unidades de medida:', error);
            }
        }
        fetchDataUnidadesMedida();
    }, []);

    const onSubmit = async (data) => {
        if (listaDeItens.length === 0) {
            mostrarAlerta("Adicione pelo menos um item à solicitação de compra!", "error");
            return;
        }
        const formData = {
            ...data,
            itens: listaDeItens,
            solicitante: funcionarioSelecionado,
            setor: setorSelecionado,
        };
        try {
            await api.post("/sc", formData);
            reset();
            setListaDeItens([]);
            mostrarAlerta("Solicitação de compra cadastrada com sucesso!", "success");
            setTimeout(() => {
                window.location.href = `/sc`;
            }, 1200);
        } catch (error) {
            console.error(error);
            mostrarAlerta("Erro ao cadastrar a solicitação de compra!", "error");
        }
    };

    return (
        <PageContainer sx={{ maxWidth: 900 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
                    Solicitação de compra
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField {...register("motivo")} label="Motivo" required fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField {...register("prioridade")} select label="Prioridade" defaultValue="" required fullWidth>
                            <MenuItem value="">Selecione...</MenuItem>
                            <MenuItem value="Alta">Alta</MenuItem>
                            <MenuItem value="Média">Média</MenuItem>
                            <MenuItem value="Baixa">Baixa</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                            control={<Checkbox {...register("obsQuimica")} defaultChecked={false} />}
                            label="Observação Química"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            label="Solicitante"
                            value={funcionarioSelecionado}
                            onChange={(e) => setFuncionarioSelecionado(e.target.value)}
                            required
                            fullWidth
                        >
                            <MenuItem value="">Selecione um funcionário</MenuItem>
                            {funcionarios.map(funcionario => (
                                <MenuItem key={funcionario.id} value={funcionario.id}>
                                    {funcionario.nome}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            label="Setor"
                            value={setorSelecionado}
                            onChange={(e) => setSetorSelecionado(e.target.value)}
                            required
                            fullWidth
                        >
                            <MenuItem value="">Selecione um setor</MenuItem>
                            {setores.map(setor => (
                                <MenuItem key={setor.id} value={setor.nome}>
                                    {setor.nome}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField {...register("infAdicionais")} label="Informações Adicionais" fullWidth />
                    </Grid>
                </Grid>

                <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                    Adicionar Item
                </Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={5}>
                        <TextField
                            label="Descrição"
                            placeholder="Descrição do item"
                            value={novoItem.descricao || ""}
                            onChange={(e) => setNovoItem({ ...novoItem, descricao: e.target.value })}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            label="Quantidade"
                            type="number"
                            inputProps={{ step: '0.01', min: 0 }}
                            value={novoItem.quantidade || ""}
                            onChange={(e) => setNovoItem({ ...novoItem, quantidade: e.target.value })}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField
                            select
                            label="Unidade de Medida"
                            value={novoItem.unidadeMedida || ""}
                            onChange={(e) => setNovoItem({ ...novoItem, unidadeMedida: e.target.value })}
                            fullWidth
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            {unidadesMedida.map(unidadeMedida => (
                                <MenuItem key={unidadeMedida.id} value={unidadeMedida.sigla}>
                                    {unidadeMedida.sigla}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Button variant="contained" color="secondary" fullWidth sx={{ height: '100%' }} onClick={adicionarItem}>
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>

                <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                    Lista
                </Typography>
                {listaDeItens.length === 0 ? (
                    <Typography color="text.secondary">Nenhum item adicionado ainda.</Typography>
                ) : (
                    <TableContainer sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Descrição</TableCell>
                                    <TableCell>Quantidade</TableCell>
                                    <TableCell align="right">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listaDeItens.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{item.descricao}</TableCell>
                                        <TableCell>{item.quantidade + ' ' + (item.unidadeMedida || '')}</TableCell>
                                        <TableCell align="right">
                                            <IconButton size="small" color="error" onClick={() => removerItem(index)}>
                                                <DeleteOutlineIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
                        Cadastrar
                    </Button>
                </Box>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default CadastroSC;
